import type { ReactNode } from 'react';
import { useAuth } from '@/store/AuthContext';
import { useSkin } from '@/store/SkinContext';
import { SKIN_ICON } from '@/components/AppShell';

export function LoginGate({ children }: { children: ReactNode }) {
  const { user, allowed, loading, error, signIn, signOut } = useAuth();
  const { skin } = useSkin();

  if (loading) {
    return (
      <div className="ld-login">
        <div className="ld-login__card">
          <p className="muted" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span className="ld-spinner" aria-hidden />
            Cargando Podios Stories, danos unos segundos…
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="ld-login">
        <div className="ld-login__card">
          <img className="ld-login__brand" src={SKIN_ICON[skin]} alt="Mundo Atletismo" width={56} height={56} />
          <h1 className="ld-login__title">Podios Stories</h1>
          <p className="ld-login__hint">
            Acceso restringido. Inicia sesión con tu cuenta de Google.
          </p>
          <button type="button" className="ld-btn ld-btn--primary" onClick={signIn} style={{ width: '100%' }}>
            Entrar con Google
          </button>
          {error ? <div className="ld-login__error">{error}</div> : null}
        </div>
      </div>
    );
  }

  if (!allowed) {
    return (
      <div className="ld-login">
        <div className="ld-login__card">
          <div className="ld-login__brand">!</div>
          <h1 className="ld-login__title">Sin acceso</h1>
          <p className="ld-login__hint">
            La cuenta <span className="mono">{user.email}</span> no está autorizada.
            Pide al admin que te añada a la whitelist.
          </p>
          <button type="button" className="ld-btn ld-btn--ghost" onClick={signOut} style={{ width: '100%' }}>
            Cerrar sesión
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
